import { render, staticRenderFns } from "./TagsGroupsTab.vue?vue&type=template&id=24ecd576"
import script from "./TagsGroupsTab.vue?vue&type=script&lang=js"
export * from "./TagsGroupsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports